module.exports = __webpack_public_path__ + "img/nlc100s.8da9da02.png";